var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9709 10.6395L9.46872 7.45431H6.35612V5.38735C6.35612 4.51594 6.79093 3.66653 8.18496 3.66653H9.6V0.954689C9.6 0.954689 8.31589 0.739502 7.08815 0.739502C4.52483 0.739502 2.84933 2.26506 2.84933 5.02675V7.45431H0V10.6395H2.84933V18.3395H6.35612V10.6395H8.9709Z",
    fill: "#EBE0D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1ff338c6f6ffc235edd672bf6ae25b1b.svg";
export { ForwardRef as ReactComponent };